import {APP_URL, ACTION_URL} from "../Config/Variables";
import {useState} from "react";
import {GoogleLogin} from "@react-oauth/google";
import {format} from "date-fns";

const GuestLogin = () => {
  document.title = 'Login - CuanCuan';
  const [error, setError] = useState(null);

  const handleLoginSuccess = async (credentialResponse) => {
    try {
      if (!credentialResponse.credential) {
        setError({
          status: 401,
          message: 'Google authentication failed. No credential received.',
          type: 'danger',
        });
        return;
      }

      const loginResponse = await checkLogin(credentialResponse.credential);
      handleLoginResponse(loginResponse);

    } catch (error) {
      console.error('[GuestLogin] handleLoginSuccess error:', error);
      setError({
        status: 500,
        message: 'Login failed: ' + error.message,
        type: 'danger',
      });
    }
  };

  const handleLoginError = () => {
    console.error('[GuestLogin] Google login failed');
    setError({
      status: 401,
      message: 'Google authentication failed. Please try again.',
      type: 'danger',
    });
  };

  const handleLoginResponse = (loginResponse) => {
    if (loginResponse?.status === 200 && loginResponse?.data) {
      const userData = loginResponse.data;
      const userGetData = {
        "google_id": userData.google_id,
        "google_photo": userData.google_user_picture || userData.profile_picture,
        "user_keyid": userData.user_keyid,
        "full_name": userData.full_name,
        "email_address": userData.email_address,
        "user_level": userData.user_level,
        "user_department": userData.user_department,
        "last_login": format(new Date(), "yyyy-MM-dd HH:mm:ss"),
        "token": userData.token,
        "token_expires_at": userData.token_expires_at
      }
      localStorage.setItem('userData', JSON.stringify(userGetData));
      localStorage.setItem('jwtToken', userData.token);
      window.location.href = APP_URL;
    } else {
      setError({
        status: loginResponse?.status || 401,
        message: loginResponse?.message || 'Login failed. Please try again.',
        type: 'danger',
      });
    }
  };

  const checkLogin = async (idToken) => {
    try {
      const loginRequest = {
        id_token: idToken
      };
      const loginFetch = await fetch(ACTION_URL + 'login', {
        method: "POST",
        headers: {"Content-Type": "application/json"},
        body: JSON.stringify(loginRequest)
      });
      const loginResponse = await loginFetch.json();
      return loginResponse;
    } catch (error) {
      console.error('[GuestLogin] checkLogin error:', error);
      throw error;
    }
  };

  return (
    <div id="guest-login">
      <div className="d-flex flex-column align-items-center justify-content-center vh-100">
        <img className="mb-5" src="/pointstar.png" alt="PointStar" width={350}/>
        <GoogleLogin
          onSuccess={handleLoginSuccess}
          onError={handleLoginError}
        />
        {error && (
          <span className={`badge badge-sm bg-${error.type} mt-3`}>
            {error.message}
          </span>
        )}
      </div>
    </div>
  );
};

export default GuestLogin;
